import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useData } from "../context/DataContext";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Checkbox } from "../components/ui/checkbox";
import { Badge } from "../components/ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import {
  ArrowLeft,
  UserPlus,
  Search,
  FileText,
  Users,
  Building2,
  CheckCircle,
  AlertCircle,
  Calendar,
  Info
} from "lucide-react";
import { toast } from "sonner";

interface MemoForAssignment {
  id: string;
  subject: string;
  number: string;
  type: 'Policy' | 'Memo';
  status: 'Draft' | 'Active' | 'Archived';
  fileUrl?: string;
  requireSignature: boolean;
  effectiveDate: string;
  expiryDate?: string;
  createdDate: string;
  lastUpdated: string;
  createdBy: {
    id: string;
    name: string;
    email: string;
  };
}

export default function MemoNewAssignPage() {
  const navigate = useNavigate();
  const { users, departments } = useData();
  const { currentUser } = useAuth();

  const [selectedMemo, setSelectedMemo] = useState<MemoForAssignment | null>(null);
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const [assignmentMode, setAssignmentMode] = useState<"individual" | "department">("individual");
  const [selectedDepartment, setSelectedDepartment] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const [departmentFilter, setDepartmentFilter] = useState<string>("all");
  const [assignmentPriority, setAssignmentPriority] = useState<string>("Med");
  const [availableMemos, setAvailableMemos] = useState<MemoForAssignment[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Get department name
  const getDepartmentName = (deptCode: string) => {
    const dept = departments.find(d => d.departmentCode === deptCode);
    return dept ? `${dept.departmentCode} - ${dept.departmentName}` : deptCode;
  };

  // if (!canManageMemos) {
  //   return (
  //     <div className="p-6">
  //       <Card>
  //         <CardContent className="p-6">
  //           <div className="text-center">
  //             <AlertCircle className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
  //             <h3 className="mb-2">Access Restricted</h3>
  //             <p className="text-muted-foreground">
  //               You don't have permission to create memo assignments. Contact your administrator if you need access.
  //             </p>
  //           </div>
  //         </CardContent>
  //       </Card>
  //     </div>
  //   );
  // }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link to="/policies?tab=assignments">
            <Button variant="outline" size="icon">
              <ArrowLeft className="h-4 w-4" />
            </Button>
          </Link>
          <div>
            <h1 className="text-2xl font-bold">New Memo Assignment</h1>
            <p className="text-muted-foreground">Assign an existing memo to users</p>
          </div>
        </div>

        <Button disabled>
          <UserPlus className="h-4 w-4 mr-2" />
          Create Assignment
        </Button>
      </div>

      {/* Coming Soon Content */}
      <Card>
        <CardContent className="p-12">
          <div className="text-center">
            <FileText className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">Memo Assignment Creation</h3>
            <p className="text-muted-foreground max-w-md mx-auto">
              This feature is coming soon. For now, you can create policy assignments and view existing memo assignments.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}